<app-side-menu>
  <div class="status-form-content">
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <h1 class="page-title">
            <i class="fas fa-tag me-3"></i>
            {{ isEditMode ? 'Editar Status' : (isViewMode ? 'Visualizar Status' : 'Novo Status') }}
          </h1>
          <p class="page-subtitle">
            {{ isViewMode ? 'Detalhes do status' : 'Preencha os dados do status' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <app-loading [show]="loading" message="Carregando..."></app-loading>

    <!-- Error -->
    <div *ngIf="error && !loading" class="alert alert-danger" role="alert">
      <i class="fas fa-exclamation-triangle me-2"></i>
      {{ error }}
    </div>

    <!-- Form -->
    <div *ngIf="!loading" class="status-form-card">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        
        <!-- Informações Básicas -->
        <div class="section-header">
          <h3 class="section-title">
            <i class="fas fa-info-circle me-2"></i>
            Informações Básicas
          </h3>
          <p class="text-muted mb-0">
            <i class="fas fa-info-circle me-1"></i>
            O código do status será gerado automaticamente com base no setor e nome. 
            A ordenação é alfabética por nome.
          </p>
        </div>

        <div class="row g-3 mb-4">
          <!-- Nome -->
          <div class="col-md-4">
            <label class="form-label">Nome <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="name"
              placeholder="Ex: Pedido Novo"
              [class.is-invalid]="hasError('name')">
            <div *ngIf="hasError('name')" class="invalid-feedback">
              {{ getErrorMessage('name') }}
            </div>
          </div>

          <!-- Setor -->
          <div class="col-md-8">
            <label class="form-label">Setor <span class="text-danger">*</span></label>
            <select
              class="form-select"
              formControlName="entityType"
              [class.is-invalid]="hasError('entityType')">
              <option value="">Selecione o setor</option>
              <option *ngFor="let entity of entityTypes" [value]="entity.value">
                [{{ entity.module }}] {{ entity.label }}
              </option>
            </select>
            <div *ngIf="hasError('entityType')" class="invalid-feedback">
              {{ getErrorMessage('entityType') }}
            </div>
          </div>

          <!-- Descrição -->
          <div class="col-12">
            <label class="form-label">Descrição</label>
            <textarea
              class="form-control"
              formControlName="description"
              rows="2"
              placeholder="Descrição detalhada do status (opcional)"></textarea>
          </div>
        </div>

        <!-- Configurações -->
        <div class="section-header">
          <h3 class="section-title">
            <i class="fas fa-cog me-2"></i>
            Configurações
          </h3>
          <p class="text-muted mb-0">
            <i class="fas fa-info-circle me-1"></i>
            O status padrão é automaticamente o primeiro status ativo em ordem alfabética
          </p>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-md-6">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
              <label class="form-check-label" for="isActive">
                <strong>Ativo</strong>
              </label>
              <div class="form-text">Status inativos não aparecem nas listagens</div>
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="form-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
            <i class="fas fa-times me-2"></i>
            Cancelar
          </button>

          <button 
            *ngIf="isViewMode" 
            type="button" 
            class="btn btn-primary" 
            (click)="edit()">
            <i class="fas fa-edit me-2"></i>
            Editar
          </button>

          <button 
            *ngIf="!isViewMode" 
            type="submit" 
            class="btn btn-primary"
            [disabled]="saving">
            <i class="fas fa-spinner fa-spin me-2" *ngIf="saving"></i>
            <i class="fas fa-save me-2" *ngIf="!saving"></i>
            {{ saving ? 'Salvando...' : (isEditMode ? 'Atualizar' : 'Criar Status') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>
